import * as Yup from 'yup'

export const TimelineItemDatesSchema = Yup.object().shape({
    startDate: Yup.date()
      .required('Start date is required')
      .max(Yup.ref('endDate'), 'Start date must be before end date'),
    endDate: Yup.date()
      .required('End date is required')
      .min(Yup.ref('startDate'), 'End date must be after start date')
  })